export function makeDropdown(dropdown: HTMLElement) {
    let content = dropdown.querySelector('.spdrop__content')
    let toggle = dropdown.querySelector('.spdrop__toggle')

    if (!content || !toggle) {
        return
    }

    toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') == 'false') {
            toggle.setAttribute('aria-expanded', 'true')
            content.classList.add('spdrop__content--active')
        } else {
            toggle.setAttribute('aria-expanded', 'false')
            content.classList.remove('spdrop__content--active')
        }
    })
}

export function safDropdown(safEls: HTMLElement[], insertAfter: HTMLElement) {
    safEls.forEach((el: HTMLElement) => {
        el.style.display = 'none'
    })

    let btn = document.createElement('button')
    btn.classList.add('spdrop__toggle', 'btn-reset', 'subhead-2')
    btn.setAttribute('aria-expanded', 'false')
    btn.setAttribute('aria-label', 'Show more filters')
    btn.innerHTML = 'Filter'

    insertAfter.insertAdjacentElement('afterend', btn)

    btn.addEventListener('click', (e) => {
        e.preventDefault()
        if (btn.getAttribute('aria-expanded') == 'false') {
            btn.setAttribute('aria-expanded', 'true')
            safEls.forEach((el: HTMLElement) => {
                el.style.display = 'block'
            })
        } else {
            btn.setAttribute('aria-expanded', 'false')
            safEls.forEach((el: HTMLElement) => {
                el.style.display = 'none'
            })
        }
    })
}
